/* FACTQRY — Bloc Recherche & Univers (vanilla, ~1KB gzip) */
(function(){
  'use strict';
  var form = document.querySelector('[data-fq-form]');
  if(!form) return;

  var input = form.querySelector('[data-fq-input]');
  var animEl = form.querySelector('[data-fq-anim-word]');
  var raw = input && input.getAttribute('data-fq-anim-src');
  var words = raw ? raw.split('||').filter(Boolean) : [];
  var i = 0, timer = null;

  function updateState(){
    form.classList.toggle('has-value', !!input.value);
  }

  function tick(){
    if(!animEl || !words.length) return;
    animEl.textContent = words[i % words.length];
    animEl.style.animation = 'none';
    void animEl.offsetWidth;
    animEl.style.animation = '';
    i++;
  }

  if(animEl && words.length){
    tick();
    timer = setInterval(tick, 2400);
  }

  input.addEventListener('focus', function(){ form.classList.add('is-focused'); });
  input.addEventListener('blur',  function(){ form.classList.remove('is-focused'); });
  input.addEventListener('input', updateState);
  updateState();

  // Pause l'animation quand l'onglet est en arrière-plan (perf + batterie)
  document.addEventListener('visibilitychange', function(){
    if(document.hidden){ clearInterval(timer); timer = null; }
    else if(animEl && words.length && !timer){ timer = setInterval(tick, 2400); }
  });
})();
